if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        window.pauseAllMedia();
        
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
          const deferredMedia = element.querySelector('deferred-media, product-model');
          if (deferredMedia) {
            const video = deferredMedia.querySelector('video');
            if (video && !video.paused) {
              video.pause();
            }
            const modelViewer = deferredMedia.querySelector('model-viewer');
            if (modelViewer && modelViewer.pause) {
              modelViewer.pause();
            }
          }
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        const deferredMedia = activeMedia.querySelector('deferred-media, product-model');
        if (deferredMedia && (deferredMedia.nodeName === 'DEFERRED-MEDIA' || deferredMedia.nodeName === 'PRODUCT-MODEL')) {
          deferredMedia.loadContent();
        }
      }
    }
  );
}
